import Resource from './common/resource';

class Links extends Resource {
  path = 'urls';
}

export default Links;
